import { Box, Chip, Tooltip } from '@mui/material'

/**
 * Formats a location type string by converting it from SNAKE_CASE to Title Case
 * @param {string} type - The location type in SNAKE_CASE format
 * @returns {string} The formatted location type in Title Case
 */
export const formatLocationType = type => {
  return type
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

/**
 * Renders location type chips with a count indicator for multiple types
 * @param {Object} location - The location object containing type information
 * @param {boolean} enableAddressPrintingUpdates - Flag to determine which type format to use
 * @returns {React.ReactNode} The rendered location type chips
 */
export const getLocationTypeChips = (location, enableAddressPrintingUpdates) => {
  const { locationType, locationTypes } = location

  if (enableAddressPrintingUpdates) {
    if (!locationTypes?.length) return null

    const formattedTypes = locationTypes.map(type => formatLocationType(type))
    const remainingCount = locationTypes.length - 1

    return (
      <Tooltip title={formattedTypes.join(', ')} placement="left">
        <Box
          sx={{
            display: 'flex',
            gap: 0.5,
            flexWrap: 'wrap',
            justifyContent: 'center',
          }}
        >
          <Chip
            label={`${formatLocationType(locationTypes[0])}${remainingCount > 0 ? ` +${remainingCount}` : ''}`}
            size="small"
            sx={{
              height: '20px',
              '& .MuiChip-label': {
                px: 1,
                fontSize: '0.75rem',
              },
            }}
          />
        </Box>
      </Tooltip>
    )
  }

  if (!locationType) return null

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.5,
        flexWrap: 'wrap',
        justifyContent: 'center',
      }}
    >
      <Chip
        label={formatLocationType(locationType)}
        size="small"
        sx={{
          height: '20px',
          '& .MuiChip-label': {
            px: 1,
            fontSize: '0.75rem',
          },
        }}
      />
    </Box>
  )
}
